
import { Options, Vue } from "vue-class-component";
import RgbaToHex from "./components/RgbaToHex.vue";

@Options({
  components: {
    RgbaToHex,
  },
})
export default class App extends Vue {
  backgroundColor = "";
  backgroundColorTransparenz = "";
  colorCalculated = "";
  colorCalculatedWithoutTrans = {
    r: 0,
    g: 0,
    b: 0
  };
  counterArray = [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0];

  calcRgba(color: any) {
    this.backgroundColor = color.color;
    this.backgroundColorTransparenz = color.color + "" + color.colorTransparenz;
    this.colorCalculated = color.colorCalculated;
    this.colorCalculatedWithoutTrans.r = color.colorCalculatedWithoutTrans.r;
    this.colorCalculatedWithoutTrans.g = color.colorCalculatedWithoutTrans.g;
    this.colorCalculatedWithoutTrans.b = color.colorCalculatedWithoutTrans.b;
  }
}
